import React from "react";
import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import TextFieldWithStyle from "../../../HOCs/InputWithStyle/InputWithStyle";

const FreeDelivery = ({ onSubmit, onCancel }) => {
	const { handleSubmit, register } = useForm();

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<h3>Agregar envío gratis</h3>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				required
				fullWidth
				id="name"
				label="Nombre del Premio"
				name="name"
				autoFocus
				type="text"
				inputRef={register({ required: true, minLength: 2 })}
			/>
			<br />
			<ButtonWithStyle onClick={handleSubmit(onSubmit)}>Guardar</ButtonWithStyle>
			<ButtonWithStyle onClick={onCancel}>Cancelar</ButtonWithStyle>
		</form>
	);
};

export default FreeDelivery;
